<template>
    <!-- commission rules container row -->
    <div class="xero-mappings w-100">
        <template>
            <el-row>
                <el-col class="p-3" :span="24">
                    <el-radio-group v-model="activeEntity" size="mini">
                        <el-radio-button label="Lenders" class="m-0">LENDERS
                            <el-badge class="mark" v-if="lenderTotal" :value="`${lenderCount} of ${lenderTotal}`"/>
                        </el-radio-button>
                        <el-radio-button label="Insurers" class="m-0">INSURERS
                            <el-badge class="mark" v-if="insurerTotal" :value="`${insurerCount} of ${insurerTotal}`"/>
                        </el-radio-button>
                        <el-radio-button label="Accounts" class="m-0">ACCOUNTS
                            <el-badge class="mark" v-if="accountTotal" :value="`${accountCount} of ${accountTotal}`"/>
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
            </el-row>

            <el-row v-if="activeEntity == 'Lenders'">
                <el-col :span="24">
                    <el-table
                        ref="xeroLenderMappings"
                        v-loading="loading.lenders"
                        :data="mappings.lenders"
                        :height="getMaxHeight()"
                        class="w-100 b-l-0"
                        row-key="id"
                        border>
                        <el-table-column
                            prop="LenderId"
                            label="Lender ID"
                            align="center"
                            width="90"
                            :show-overflow-tooltip=true>
                            <template slot-scope="{row}">
                                <span>{{ row.id }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="Lender Name"
                            :show-overflow-tooltip=true>
                            <template slot-scope="{row}">
                                <span>{{ row.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="email"
                            label="Lender Email"
                            :show-overflow-tooltip=true>
                            <template slot-scope="{row}">
                                <span>{{ row.email }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="xeroId"
                            label="Xero Provider"
                        >
                            <template slot-scope="{row}">
                                <el-select
                                    v-model="row.tenant_xero"
                                    size="mini"
                                    value-key="xero_id"
                                    class="input-belt w-100"
                                    popper-class="el-select-tenant-comms"
                                    :loading="loading.xero.providers"
                                    filterable
                                    placeholder="ALL"
                                    remote
                                    reserve-keyword
                                    :remote-method="searchXeroProviders"
                                    @focus="xero.providers = []"
                                >
                                    <el-option-group label="Providers">
                                        <template
                                            v-if="!xero.providers.length && row.tenant_xero && row.tenant_xero.xero_id">
                                            <el-option
                                                :key="`${row.tenant_xero.xero_id}`"
                                                :label="`${row.tenant_xero.xero_label} ${row.tenant_xero.xero_object.AccountNumber ? '(' + row.tenant_xero.xero_object.AccountNumber + ')' : ''} `"
                                                :value="row.tenant_xero"
                                            ></el-option>
                                        </template>
                                        <template v-else>
                                            <el-option
                                                v-for="(item, idx) in xero.providers"
                                                :key="idx"
                                                :label="`${item.xero_label || ''} ${item.xero_object.AccountNumber ? '(' + item.xero_object.AccountNumber + ')' : ''} `"
                                                :value="item"
                                            ></el-option>
                                        </template>
                                    </el-option-group>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="xeroId"
                            label="Xero Tracking Category"
                        >
                            <template slot-scope="{row}" v-if="row.tenant_xero">
                                <el-select
                                    v-model="row.tenant_xero.tracking"
                                    size="mini"
                                    value-key="xero_id"
                                    class="input-belt w-100"
                                    popper-class="el-select-tenant-comms"
                                    :loading="loading.xero.tracking"
                                    filterable
                                    placeholder="ALL"
                                    reserve-keyword
                                    @focus="getXeroTrackingProviders"
                                >
                                    <template
                                        v-if="!xero.tracking.length && row.tenant_xero.tracking && row.tenant_xero.tracking.xero_id">
                                        <el-option
                                            :key="`${row.tenant_xero.tracking.xero_id}`"
                                            :label="`${row.tenant_xero.tracking.xero_label}`"
                                            :value="row.tenant_xero.tracking"
                                        ></el-option>
                                    </template>
                                    <el-option-group
                                        v-for="(item, idx) in xero.tracking"
                                        :key="`${item.xero_id || idx}`"
                                        :label="item.xero_label">
                                        <el-option
                                            v-for="(option, idxOption) in item.options"
                                            :key="`${option.xero_id || idxOption}`"
                                            :label="`${option.xero_label || ''}`"
                                            :value="option"
                                        ></el-option>
                                    </el-option-group>
                                </el-select>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="m-3">
                        <button class="btn btn-success" @click="saveLenderMappings">Save Mappings</button>
                        <button class="btn btn-primary" @click="getLenders();getXeroProviders();">Load Mappings</button>
                        <button class="btn btn-light" @click="clearXeroCache">Clear Cache</button>
                    </div>
                </el-col>
            </el-row>

            <el-row v-if="activeEntity == 'Insurers'">
                <el-col :span="24">
                    <el-table
                        ref="xeroLenderMappings"
                        v-loading="loading.insurers"
                        :data="mappings.insurers"
                        :height="getMaxHeight()"
                        class="w-100 b-l-0"
                        row-key="id"
                        border
                    >
                        <el-table-column
                            prop="InsurerId"
                            label="Insurer ID"
                            align="center"
                            width="90"
                            :show-overflow-tooltip=true>
                            <template slot-scope="{row}">
                                <span>{{ row.id }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="Insurer Name"
                            :show-overflow-tooltip=true>
                            <template slot-scope="{row}">
                                <span>{{ row.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="email"
                            label="Insurer Email"
                            :show-overflow-tooltip=true>
                            <template slot-scope="{row}">
                                <span>{{ row.email }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="xeroId"
                            label="Xero Provider"
                        >
                            <template slot-scope="{row}">
                                <el-select
                                    v-model="row.tenant_xero"
                                    size="mini"
                                    value-key="xero_id"
                                    class="input-belt w-100"
                                    popper-class="el-select-tenant-comms"
                                    :loading="loading.xero.insurers"
                                    filterable
                                    placeholder="ALL"
                                    reserve-keyword
                                    @focus="getXeroInsurers"
                                >
                                    <el-option-group label="Insurers">
                                        <template
                                            v-if="!xero.insurers.length && row.tenant_xero && row.tenant_xero.xero_id">
                                            <el-option
                                                :key="`${row.tenant_xero.xero_id}`"
                                                :label="`${row.tenant_xero.xero_label} ${row.tenant_xero.xero_object.AccountNumber ? '(' + row.tenant_xero.xero_object.AccountNumber + ')' : ''} `"
                                                :value="row.tenant_xero"
                                            ></el-option>
                                        </template>
                                        <el-option
                                            v-for="(item, idx) in xero.insurers"
                                            :key="idx"
                                            :label="`${item.xero_label || ''} ${item.xero_object.AccountNumber ? '(' + item.xero_object.AccountNumber + ')' : ''} `"
                                            :value="item"
                                        ></el-option>
                                    </el-option-group>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="xeroId"
                            label="Xero Tracking Category"
                        >
                            <template slot-scope="{row}" v-if="row.tenant_xero">
                                <el-select
                                    v-model="row.tenant_xero.tracking"
                                    size="mini"
                                    value-key="xero_id"
                                    class="input-belt w-100"
                                    popper-class="el-select-tenant-comms"
                                    :loading="loading.xero.tracking"
                                    filterable
                                    placeholder="ALL"
                                    reserve-keyword
                                    @focus="getXeroTrackingProviders"
                                >
                                    <template
                                        v-if="!xero.tracking.length && row.tenant_xero.tracking && row.tenant_xero.tracking.xero_id">
                                        <el-option
                                            :key="`${row.tenant_xero.tracking.xero_id}`"
                                            :label="`${row.tenant_xero.tracking.xero_label}`"
                                            :value="row.tenant_xero.tracking"
                                        ></el-option>
                                    </template>
                                    <el-option-group
                                        v-for="(item, idx) in xero.tracking"
                                        :key="`${item.xero_id || idx}`"
                                        :label="item.xero_label">
                                        <el-option
                                            v-for="(option, idxOption) in item.options"
                                            :key="`${option.xero_id || idxOption}`"
                                            :label="`${option.xero_label || ''}`"
                                            :value="option"
                                        ></el-option>
                                    </el-option-group>
                                </el-select>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="m-3">
                        <button class="btn btn-success" @click="saveInsurerMappings">Save Mappings</button>
                        <button class="btn btn-primary" @click="getInsurers();getXeroInsurers();">Load Mappings</button>
                        <button class="btn btn-light" @click="clearXeroCache">Clear Cache</button>
                    </div>
                </el-col>
            </el-row>

            <el-row v-if="activeEntity == 'Accounts'">
                <el-col :span="24">
                    <el-table
                        ref="xeroAccountMappings"
                        v-loading="loading.accounts"
                        :data="mappings.accounts"
                        row-key="id"
                        :height="getMaxHeight()"
                        class="w-100 b-l-0"
                        border>
                        <el-table-column
                            prop="id"
                            label="ID"
                            align="center"
                            width="90"
                            :show-overflow-tooltip=true>
                            <template slot-scope="{row}">
                                <span>{{ row.id }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="Account Type"
                            :show-overflow-tooltip=true>
                            <template slot-scope="{row}">
                                <span>{{ row.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :hidden="true"
                            :show-overflow-tooltip=true>
                            <template>
                                <span></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="xeroId"
                            label="Xero Account"
                            :show-overflow-tooltip=true>
                            <template slot-scope="{row}">
                                <el-select
                                    v-model="row.tenant_xero"
                                    size="mini"
                                    value-key="xero_id"
                                    class="input-belt w-100"
                                    popper-class="el-select-tenant-comms"
                                    :loading="loading.xero.accounts"
                                    filterable
                                    placeholder="ALL"
                                    reserve-keyword
                                    @focus="getXeroAccounts"
                                >
                                    <el-option-group label="Accounts">
                                        <template
                                            v-if="!xero.accounts.length && row.tenant_xero && row.tenant_xero.xero_id">
                                            <el-option
                                                :key="`${row.tenant_xero.xero_id}`"
                                                :label="`${row.tenant_xero.xero_object.Code ? row.tenant_xero.xero_object.Code + ' - ' : ''}${row.tenant_xero.xero_label}`"
                                                :value="row.tenant_xero"
                                            ></el-option>
                                        </template>
                                        <el-option
                                            v-for="(item, idx) in xero.accounts"
                                            :key="idx"
                                            :label="`${item.xero_object.Code ? item.xero_object.Code + ' - ' : ''}${item.xero_label}`"
                                            :value="item"
                                        ></el-option>
                                    </el-option-group>
                                </el-select>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="m-3">
                        <button type="button" class="btn btn-success" @click="saveAccountMappings">Save Mappings
                        </button>
                        <button type="button" class="btn btn-primary" @click="getAccounts();getXeroAccounts();">Load
                            Mappings
                        </button>
                        <button type="button" class="btn btn-light" @click="clearXeroCache">Clear Cache</button>
                    </div>
                </el-col>
            </el-row>
        </template>
    </div>
</template>

<script>
export default {
    name: "XeroMappings",
    props: {
        connection: [Object, Array]
    },
    components: {},
    data() {
        return {
            activeEntity: 'Lenders',
            loading: {
                tenants: false,
                lenders: false,
                insurers: false,
                accounts: false,
                xero: {
                    subOriginators: false,
                    providers: false,
                    insurers: false,
                    accounts: false,
                    tracking: false,
                }
            },
            xero: {
                subOriginators: [],
                providers: [],
                insurers: [],
                accounts: [],
                tracking: [],
            },
            counts: {
                tenants: {
                    mapped: null,
                    total: null
                },
                lenders: {
                    mapped: null,
                    total: null
                },
                insurers: {
                    mapped: null,
                    total: null
                },
                accounts: {
                    mapped: null,
                    total: null
                }
            },
            mappings: {
                tenants: [],
                lenders: [],
                insurers: [],
                accounts: []
            }
        };
    },
    mounted() {

        this.getTenants();
        this.getLenders();
        this.getInsurers();
        this.getAccounts();
        // this.getXeroSubOriginators();
        // this.getXeroProviders();
        // this.getXeroInsurers();

    },
    computed: {
        lenderCount() {
            return this.mappings.lenders.filter((lender) => _.get(lender, 'tenant_xero')).length;
        },
        lenderTotal() {
            return this.mappings.lenders.length;

        },
        insurerCount() {
            return this.mappings.insurers.filter((insurer) => _.get(insurer, 'tenant_xero')).length;

        },
        insurerTotal() {
            return this.mappings.insurers.length;

        },
        accountCount() {
            return this.mappings.accounts.filter((account) => _.get(account, 'tenant_xero')).length;

        },
        accountTotal() {
            return this.mappings.accounts.length;

        }
    },
    methods: {

        getMaxHeight() {
            return ($('.el-main').height() - 155) + 'px';
        },

        activeSelection(entity) {

            if (this.activeEntity == entity) {
                return 'always';
            } else {
                return 'never';
            }

        },

        // map xero id & label onto row object
        propertyChange(scope, row, value) {

            Object.assign(row, value);

        },

        clearXeroCache() {

            try {

                this.$tenant.get("/api/xero/clear-cache")
                    .then(res => {
                        // cache cleared
                        this.xero.subOriginators = [];
                        this.xero.providers = [];
                        this.xero.insurers = [];
                        this.xero.accounts = [];
                        this.xero.tracking = [];
                        this.xero.insurers = [];

                        this.$message({
                            message: 'Xero cache cleared',
                            type: 'success'
                        });

                    });

            } catch (err) {
                console.error(err);
            }

        },

        getTenants() {

            try {
                this.loading.tenants = true;

                this.$tenant.get("/admin/accounting/mappings/tenants")
                    .then(res => {
                        if (res && res.data) {
                            this.mappings.tenants = res.data.tenantMappings;
                            this.counts.tenants.mapped = res.data.tenantMappedCount;
                            this.counts.tenants.total = res.data.tenantCount;
                        }
                    })
                    .finally(() => {
                        this.loading.tenants = false;
                    });


            } catch (err) {
                console.error(err);
                this.loading.tenants = false;
            }

        },

        getXeroSubOriginators() {

            try {

                if (this.xero.subOriginators.length) {
                    return;
                }

                this.loading.xero.subOriginators = true;

                this.$tenant.get("/api/xero/sub-originators")
                    .then(res => {
                        if (res && res.data) {
                            this.xero.subOriginators = res.data.subOriginators || [];
                            this.xero.providers = res.data.providers || [];
                        }
                    })
                    .finally(() => {
                        this.loading.xero.subOriginators = false;
                        // force dropdown items to display
                        $('.el-select-dropdown').find('.el-select-group__wrap').css('display', 'block');
                    });


            } catch (err) {
                console.error(err);
                this.loading.xero.subOriginators = false;
            }

        },

        getXeroTrackingSubOriginators() {

            try {

                if (this.xero.tracking.length) {
                    return;
                }

                let params = {
                    params: {
                        'tracking-category': 'Tenants'
                    }
                };

                this.loading.xero.tracking = true;

                this.$tenant.get("/api/xero/tracking-options", params)
                    .then(res => {
                        this.xero.tracking = res && res.data ? res.data : [];
                    })
                    .finally(() => {
                        this.loading.xero.tracking = false;
                        // force dropdown items to display
                        $('.el-select-dropdown').find('.el-select-group__wrap').css('display', 'block');
                    });


            } catch (err) {
                console.error(err);
                this.loading.xero.tracking = false;
            }

        },

        saveTenantMappings() {

            try {

                let params = {
                    subOriginators: this.mappings.tenants
                };

                this.loading.tenants = true;

                this.$tenant.put("/api/xero/sub-originators", params)
                    .then(res => {
                    })
                    .finally(() => {
                        this.loading.tenants = false;
                    });


            } catch (err) {
                console.error(err);
                this.loading.tenants = false;
            }

        },

        getLenders() {

            try {

                this.loading.lenders = true;

                this.$tenant.get("/admin/accounting/mappings/lenders")
                    .then(res => {
                        if (res && res.data) {
                            this.mappings.lenders = res.data.lenderMappings;
                            this.counts.lenders.mapped = res.data.lenderMappedCount;
                            this.counts.lenders.total = res.data.lenderCount;
                        }
                    })
                    .finally(() => {
                        this.loading.lenders = false;
                    });


            } catch (err) {
                console.error(err);
                this.loading.lenders = false;
            }

        },

        searchXeroProviders(query) {

            this.loading.xero.providers = true;

            this.getXeroProviders(query);

        },

        getXeroProviders: _.debounce(async function (query) {

            try {

                this.xero.providers = [];

                let params = {
                    params: {
                        query: query
                    }
                };

                this.loading.xero.providers = true;

                await axios.get("/api/xero/providers", params)
                    .then(res => {
                        this.xero.providers = res && res.data ? res.data : [];
                    })
                    .finally(() => {
                        this.loading.xero.providers = false;
                        // force dropdown items to display
                        $('.el-select-dropdown').find('.el-select-group__wrap').css('display', 'block');
                    });


            } catch (err) {
                console.error(err);
                this.loading.xero.providers = false;
            }

        }, 500),


        getXeroTrackingProviders() {

            try {

                if (this.xero.tracking.length) {
                    return;
                }

                let params = {
                    params: {
                        'tracking-category': 'Provider'
                    }
                };

                this.loading.xero.tracking = true;

                this.$tenant.get("/api/xero/tracking", params)
                    .then(res => {
                        this.xero.tracking = res && res.data ? res.data : [];
                    })
                    .finally(() => {
                        this.loading.xero.tracking = false;
                        // force dropdown items to display
                        $('.el-select-dropdown').find('.el-select-group__wrap').css('display', 'block');
                    });


            } catch (err) {
                console.error(err);
                this.loading.xero.tracking = false;
            }

        },

        saveLenderMappings() {

            try {

                let params = {
                    providers: this.mappings.lenders
                };

                this.loading.lenders = true;

                this.$tenant.put("/api/xero/providers", params)
                    .then(res => {
                    })
                    .finally(() => {
                        this.loading.lenders = false;
                    });


            } catch (err) {
                console.error(err);
                this.loading.lenders = false;
            }

        },

        getInsurers($event) {

            try {

                let event = $event;

                this.loading.insurers = true;

                this.$tenant.get("/admin/accounting/mappings/insurers")
                    .then(res => {
                        if (res && res.data) {
                            this.mappings.insurers = res.data.insurerMappings;
                            this.counts.insurers.mapped = res.data.insurerMappedCount;
                            this.counts.insurers.total = res.data.insurerCount;
                        }
                    })
                    .finally(() => {
                        this.loading.insurers = false;
                    });


            } catch (err) {
                console.error(err);
                this.loading.insurers = false;
            }

        },

        getXeroInsurers() {

            try {

                if (this.xero.insurers.length) {
                    return;
                }

                this.loading.xero.insurers = true;

                this.$tenant.get("/api/xero/insurers")
                    .then(res => {
                        this.xero.insurers = res && res.data ? res.data : [];
                    })
                    .finally(() => {
                        this.loading.xero.insurers = false;
                        // force dropdown items to display
                        $('.el-select-dropdown').find('.el-select-group__wrap').css('display', 'block');
                    });


            } catch (err) {
                console.error(err);
                this.loading.xero.insurers = false;
            }

        },

        saveInsurerMappings() {

            try {

                let params = {
                    insurers: this.mappings.insurers
                };

                this.loading.insurers = true;

                this.$tenant.put("/api/xero/insurers", params)
                    .then(res => {
                    })
                    .finally(() => {
                        this.loading.insurers = false;
                    });


            } catch (err) {
                console.error(err);
                this.loading.insurers = false;
            }

        },

        getAccounts($event) {

            try {

                let event = $event;

                this.loading.accounts = true;

                this.$tenant.get("/admin/accounting/mappings/accounts")
                    .then(res => {
                        if (res && res.data) {
                            this.mappings.accounts = res.data.accountMappings;
                            this.counts.accounts.mapped = res.data.accountMappedCount;
                            this.counts.accounts.total = res.data.accountCount;
                        }
                    })
                    .finally(() => {
                        this.loading.accounts = false;
                    });


            } catch (err) {
                console.error(err);
                this.loading.accounts = false;
            }

        },

        getXeroAccounts() {

            try {

                if (this.xero.accounts.length) {
                    return;
                }

                this.loading.xero.accounts = true;

                this.$tenant.get("/api/xero/accounts")
                    .then(res => {
                        this.xero.accounts = res && res.data ? res.data : [];
                    })
                    .finally(() => {
                        this.loading.xero.accounts = false;
                        // force dropdown items to display
                        $('.el-select-dropdown').find('.el-select-group__wrap').css('display', 'block');
                    });


            } catch (err) {
                console.error(err);
                this.loading.xero.accounts = false;
            }

        },
        saveAccountMappings() {
            try {
                let params = {
                    accounts: this.mappings.accounts
                };

                this.loading.accounts = true;

                this.$tenant.put("/api/xero/accounts", params)
                    .then(res => {
                    })
                    .finally(() => {
                        this.loading.accounts = false;
                    });
            } catch (err) {
                console.error(err);
                this.loading.accounts = false;
            }
        },
    }
};
</script>

<style lang="scss">

.xero-mappings {

    .el-badge.mark sup.el-badge__content {
        border: none;
        top: 0;
    }

    .el-radio-button .el-radio-button__inner {
        border-radius: 0px !important;
        padding: 12px 20px !important;
        line-height: 24px;
    }

    .el-badge.mark {
        background-color: transparent;
        padding: 0px;

        * {
            border: none;
            top: 0;
        }
    }

    .search-comp-input input,
    .input-belt input,
    .multi-row-input,
    .input-row input,
    .select-belt select,
    .select-row select,
    .multi-row-select,
    select,
    .input-results-dropdown .found-results,
    .select2-container--default .select2-selection--single {
        height: 2rem !important;
        font-size: 12px !important;
    }

    .el-table {

        font-size: 12px;

        th.is-leaf .cell {
            white-space: nowrap;
        }

        .el-link--inner {
            font-size: 12px;
        }

        .el-table__row.expanded td {
            background-color: #fafafa;
        }

    }

}

</style>
